import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoadingTask } from "../tools/ui/loading-task";
import { Router } from "@angular/router";
import { BaseService } from "./base.service";
import { catchError, finalize, map } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class ELIMSJobService extends BaseService {
    private serviceUrl = `${environment.GSPServiceBaseUrl}api/elimsJob`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);

    }

    reset(interventionId: number) {
        this.loadingTask.activateLoading();

        return this.http.post(`${this.serviceUrl}/reset/${interventionId}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('reset')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }
}